import Skeleton from '@mui/material/Skeleton';
import { useEffect, useState } from 'react';

import Oops from '~/common/components/Oops';
import { useSelectedAlert } from '~/stores/navigationStore';

import {
  StyledContainer,
  StyledIframe,
} from './StyledComponents/PDFViewer.styles';

type PDFViewerProps = {
  isLoading: boolean;
  isError: boolean;
  pdfBlobUrl?: Blob;
};

const PDFViewer = (props: PDFViewerProps) => {
  const selectedAlert = useSelectedAlert();

  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (props.pdfBlobUrl) {
      const url = URL.createObjectURL(props.pdfBlobUrl);
      setObjectUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [props.pdfBlobUrl]);

  return (
    <StyledContainer as="article">
      {props.isLoading && (
        <Skeleton
          data-testid="pdfviewer-skeleton"
          variant="rectangular"
          width="100%"
          height="100%"
        />
      )}
      {props.isError && <Oops />}
      {objectUrl && !props.isLoading && !props.isError && (
        <StyledIframe
          allow="fullscreen"
          title={selectedAlert?.ruleReference?.id?.toString()}
          src={`${objectUrl}#view=fitH`}
          id="documentViewer"
        />
      )}
    </StyledContainer>
  );
};

export default PDFViewer;
